<template>
  <div class="index-warning">
    <div class="index-other">
      <div
          class="other-inner flex"
          :class="{'other-top': ind > 0}"
          v-for="(val,ind) in data"
          :key="ind">
        <img :src="val.image" class="other-img"/>

        <div class="other-last">
          <div class="flex flex-width margin-bottom-8">
            MSKU <span class="text-ellipsis-1 color-grey">{{ val.msku | defaultShow }}</span>
            <span style="display: inline-block; width: 10px">
              <gj-copy-icon class="icon-show" v-if="val.msku" :content="val.msku"></gj-copy-icon>
            </span>
          </div>

          <div class="flex flex-width">
            ASIN
            <gj-link :href="val.asinUrl" target="_blank" class="text-ellipsis-1">{{ val.asin | defaultShow }}</gj-link>
            <span style="display: inline-block; width: 10px">
              <gj-copy-icon class="icon-show" v-if="val.asin" :content="val.asin"></gj-copy-icon>
            </span>
          </div>
        </div>
        <div class="other-middle" :class="clientWidth>1366?'other-width':'other-small'" v-if="warnTitleCode==='DATA_INDEX_WARN_003' || warnTitleCode==='DATA_INDEX_WARN_001'">
          <div class="margin-bottom-8">上周销量 <span>({{ val.saleLastWeekDay }})</span>
            ：{{ val.saleLastWeek | defaultShow }}
          </div>
          <div>本周销量<span>({{ val.salesWeekDay }})</span> ：{{ val.salesWeek | defaultShow }}</div>
        </div>

        <div class="other-middle" v-else>
          <div class="margin-bottom-8">昨日销量<span>({{ val.yesterday }})</span>
            ：{{ val.yesterdaySaleQuantity | defaultShow }}
          </div>
          <div>今日销量<span>({{ val.today }})</span> ：{{ val.todaySaleQuantity | defaultShow }}</div>
        </div>

        <div class="other-next">
          <!--          周销量长与跌，日销量长与跌 应该分开的 -->
          <!--          周销量暴涨-->
          <template v-if="warnTitleCode === 'DATA_INDEX_WARN_001'">
            销量暴涨 ：{{ val.overAllRise | defaultShow }} %
          </template>

          <template v-else-if="warnTitleCode === 'DATA_INDEX_WARN_002'">
            销量暴涨 ：{{ val.rise | defaultShow }} %
          </template>

          <!--          周销量异常-->
          <template v-if="warnTitleCode === 'DATA_INDEX_WARN_003'">
            销量下跌 ：{{ val.overAllFall  | defaultShow }} %
          </template>

          <template v-if="warnTitleCode === 'DATA_INDEX_WARN_004'">
            销量下跌 ：{{ val.fall | defaultShow }} %
          </template>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "weekly-sales",
  props: {
    data: {
      type: [Array, Object],
      default: null
    },
    warnTitleCode: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.index-warning {
  height: calc(100% - 31px);
  overflow-y: auto;
  padding-right: 8px;


  .week-border-left {
    border-left: 1px solid #E4E5E6;
    padding-left: 18px;
  }

  .index-other {
    .other-top {
      padding-top: 12px;
    }

    .icon-show {
      display: none;
    }

    &:hover {
      .icon-show {
        display: inline-block;
      }
    }

    .other-inner {
      line-height: 20px;
      color: #333;
      border-bottom: 1px solid #D8DADD;
      padding-bottom: 12px;

      .other-img {
        width: 40px;
        height: 32px;
        margin-top: 4px;
      }

      .other-last {
        font-size: 12px;
        color: #999;
        padding-left: 12px;

        .flex-width{
          width: 170px;
          height: 20px;
        }

        .text-ellipsis-1 {
          max-width: 106px;
          margin-left: 12px;
          word-break: break-all;
        }

        .color-grey {
          color: #333;
        }

        /deep/ .el-icon-copy-document {
          color: #979797;
          font-size: 12px;
          line-height: 20px;
        }
      }

      .other-middle {
        width: 200px;
        font-size: 12px;
        margin: 0 130px;

        span {
          color: #999;
          margin-left: 4px;
        }
      }

      .other-width{
        margin: 0 130px;
        width: 260px;
      }

      .other-small{
        margin: 0 100px;
        width: 260px;
      }

      .other-next {
        font-size: 14px;
        font-weight: bold;
        line-height: 22px;
      }

      .margin-bottom-8 {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
